import * as React from "react";
import type { SVGProps } from "react";
const SvgFileShield01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.2 21.6H7.8A3.6 3.6 0 0 1 4.2 18V6a3.6 3.6 0 0 1 3.6-3.6h8.4A3.6 3.6 0 0 1 19.8 6v3m-6 5.7 1.39-.695a3.6 3.6 0 0 1 3.22 0l1.39.695v3.345c0 1.155-1.068 1.935-3 3.155-1.932-1.22-3-2.25-3-3.155z"
    />
  </svg>
);
export default SvgFileShield01;
